import React from 'react'
import PropTypes from 'prop-types'

const Header = (props) => (
    <header id="header" style={props.timeout ? {display: 'none'} : {}}>
        <div className="logo">
            <span className="icon fa-sitemap"></span>
        </div>
        <div className="content">
            <div className="inner">
                <h1>Serek.eu</h1>
                <p>A collection of personal websites<br />
                </p>
            </div>
        </div>
        <nav>
            <ul>
                <li><a href="https://odd-one-out.serek.eu/">Odd One Out</a></li>
                <li><a href="https://payments.serek.eu/">Payments</a></li>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('about')}}>About</a></li>
            </ul>
        </nav>
    </header>
)

Header.propTypes = {
    onOpenArticle: PropTypes.func,
    timeout: PropTypes.bool
}

export default Header
